import { useTranslations } from 'use-intl';
import { useState } from 'react';
import LiquidityChart from '@/presentation/components/charts/LiquidityChart';
import { Address, Token } from 'nftx.js';

const RangeChart = ({
  feeTier,
  currentTick,
  tickLower,
  tickUpper,
  inputTokens,
  liquidity,
  poolAddress,
  userLiquidity,
}: {
  tickLower?: bigint;
  tickUpper?: bigint;
  feeTier: number;
  currentTick: string;
  fullRange: boolean;
  isEthOnly: boolean;
  isNftOnly: boolean;
  inputTokens: Token[];
  liquidity: bigint;
  poolAddress: Address | undefined;
  userLiquidity: bigint;
}) => {
  const t = useTranslations('CreateLiquidityPositionForms.SetRange');
  const [zoomLevel, setZoomLevel] = useState(5);

  // TODO
  const { invalidRange, invalidEth, invalidNft, isInvalid } = {
    invalidEth: false,
    invalidNft: false,
    invalidRange: false,
    isInvalid: false,
  };

  return (
    <div className="relative w-full rounded-md overflow-hidden">
      {isInvalid && (
        <div className="absolute inset-0 rounded-md bg-gray-300 bg-opacity-50 grid place-content-center text-sm font-medium">
          {t(
            invalidRange
              ? 'chart.invalid'
              : invalidEth
              ? 'chart.ethOnly'
              : invalidNft
              ? 'chart.nftOnly'
              : 'chart.invalid'
          )}
        </div>
      )}
      <LiquidityChart
        feeTier={feeTier}
        tickLower={tickLower}
        tickUpper={tickUpper}
        inputTokens={inputTokens}
        liquidity={liquidity}
        poolAddress={poolAddress}
        tick={BigInt(currentTick.toString())}
        userLiquidity={userLiquidity}
      />
      {
        // @todo jackieboi get zoom working
      }
      {/* <menu className="absolute top-1 right-1 flex space-x-1">
        <button
          type="button"
          className={`p-1 rounded-full bg-gray-50 border border-gray-300 w-6 h-6 text-gray-500 text-lg grid place-content-center shadow-sm font-medium disabled:cursor-not-allowed disabled:opacity-50`}
          onClick={() => setZoomLevel((x) => x * 2)}
        >
          {'-'}
        </button>
        <button
          type="button"
          className={`p-1 rounded-full bg-gray-50 border border-gray-300 w-6 h-6 text-gray-500 text-lg grid place-content-center shadow-sm font-medium disabled:cursor-not-allowed disabled:opacity-50`}
          onClick={() => setZoomLevel((x) => Math.max(5, x / 2))}
          disabled={zoomLevel <= 5}
        >
          {'+'}
        </button>
      </menu> */}
    </div>
  );
};

export default RangeChart;
